export const Causal = [
    {
        codigoCausal: 0,
        textoCausal: "0 EMPRESA TRASLADO"
    }, {
        codigoCausal: 1,
        textoCausal: "1 NO CUMPLE TIEMPO"
    }, {
        codigoCausal: 2,
        textoCausal: "2 EMPRESA EN MORA"
    }, {
        codigoCausal: 3,
        textoCausal: "3 EMPRESA NUEVA"
    }];

export const obtenerCausal = (codigoCausal: number) => {
    return Causal.find(causal => causal.codigoCausal === codigoCausal);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/gestion_empresas_trasladables/modelo/Causal.ts